import { createFileRoute, redirect } from '@tanstack/react-router';
import { FEATURE_FLAGS } from '@vizit/constants';
import { getFeatureFlag } from '@vizit/feature-flags';
import { TagManagerPage } from '../../../../pages';
import { PagesProvider } from '../../../../pages/providers/pages-provider';
import { beforeLoadAuthenticatedValidation } from '../../../../router';
import { NavbarPageTemplate } from '../../../../templates';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug/settings/tags')({
  staticData: {
    pageName: 'Tags',
  },
  beforeLoad: async ({ context, location, params }) => {
    await beforeLoadAuthenticatedValidation(context, location);

    const isTaggingEnabled = await getFeatureFlag(FEATURE_FLAGS.TAGGING_FE, false);
    if (!isTaggingEnabled) {
      throw redirect({ to: '/w/$workspaceSlug', params: { workspaceSlug: params.workspaceSlug } });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PagesProvider template={NavbarPageTemplate}>
      <TagManagerPage />
    </PagesProvider>
  );
}
